require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./journal-the-commercial-project-one-five-six-the-local-project.json") })
        }
      }, "path---journal-the-commercial-project-one-five-six-the-local-project");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---journal-the-commercial-project-one-five-six-the-local-project!./.cache/json/journal-the-commercial-project-one-five-six-the-local-project.json
// module id = 536
// module chunks = 231608221292675